import { render } from "./AppLogin.vue?vue&type=template&id=b65d36e8"
import script from "./AppLogin.vue?vue&type=script&lang=js"
export * from "./AppLogin.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__